// @ts-nocheck
import { z } from "zod";
export const edgeSchema = z.object({ "target": z.string(), "condition": z.string(), "label": z.union([z.string(), z.null()]).default(null) });
